const ua = window.navigator.userAgent;
//
const isWebKit = ua.includes("AppleWebKit");
const isSafari = ua.includes("Safari");
const isVersion = ua.includes("Version");
const isWKWebView = isWebKit && !isSafari && !isVersion;
//
const isEyeJackApp = ua.includes('EyeJack');
const isBabylonNative = ua.includes('BabylonNative');
//
export const IS_EYEJACK_APP = isEyeJackApp;
export const IS_EYEJACK_WEBXR_POLYFILL = isEyeJackApp && !isBabylonNative && isWKWebView;
export const IS_BABYLON_NATIVE = isEyeJackApp && isBabylonNative;
export const IS_BABYLON_NATIVE_WEBVIEW = isEyeJackApp && isBabylonNative && isWKWebView;
export const IS_BABYLON_NATIVE_JSCORE = isEyeJackApp && isBabylonNative && !isWKWebView;
/**
 * @deprecated EJApp is deprecated, use IS_EYEJACK_APP instead.
 */
export const EJApp = IS_EYEJACK_APP;

export default class Utils {
  static UUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}
